import { Injectable } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { Observable } from "rxjs/index";
import { STORE_FEATURE_KEY_SOUND_PROFILE } from "./sound-profile.reducer";
import { SoundProfileResponse } from "../types/sound-profile-response";

const loadingSelector = (appState: any) =>
  appState[STORE_FEATURE_KEY_SOUND_PROFILE].loading;
const getSoundProfile = (appState: any): SoundProfileResponse =>
  appState[STORE_FEATURE_KEY_SOUND_PROFILE].soundProfile;
const getParentProfiles = (appState: any) =>
  appState[STORE_FEATURE_KEY_SOUND_PROFILE].parentProfiles;
const getScannedSoundProfile = (appState: any): SoundProfileResponse =>
  appState[STORE_FEATURE_KEY_SOUND_PROFILE].scannedSoundProfile;

@Injectable()
export class SoundProfileSelectors {
  constructor(private store: Store<any>) {}

  selectLoading(): Observable<boolean> {
    return this.store.pipe(select(loadingSelector));
  }

  selectGetSoundProfile(): Observable<SoundProfileResponse> {
    return this.store.pipe(select(getSoundProfile));
  }

  selectGetParentProfiles(): Observable<any> {
    return this.store.pipe(select(getParentProfiles));
  }

  selectGetScannedSoundProfile(): Observable<SoundProfileResponse> {
    return this.store.pipe(select(getScannedSoundProfile));
  }
}
